import { jsx, jsxs } from "react/jsx-runtime";
const Trash2 = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsxs("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1ZM15 11a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z",
                fill: "none",
                className: "tw-fill-current"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 2a2 2 0 0 0-2 2v2H4a1 1 0 0 0 0 2h.08L5 19.046A3 3 0 0 0 8 22h8a3 3 0 0 0 3-2.954L19.92 8H20a1 1 0 1 0 0-2h-4V4a2 2 0 0 0-2-2h-4Zm4 4V4h-4v2h4ZM6.087 8l.91 10.917A1 1 0 0 1 7 19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 1 1 0 0 1 .003-.083L17.913 8H6.087Z",
                fill: "none",
                className: "tw-fill-current"
            })
        ]
    });
const Trash2_Trash2 = Trash2;
export default Trash2_Trash2;
